import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import jsRedirect from '../../../helpers/jsRedirect';
import { Col } from '../../base/Grid';
import Link from '../../base/Link';
// icon imports
import caratRight from '../../icons/utility/CaratRight';

import {
  ButtonCondensedCardOverlayStyled,
  ColLinkContainerStyled,
  DivProductCalloutCardStyled,
  IconCardTitleStyled,
  ProductCalloutRow,
  RowHeaderStyled,
  Styles,
  TypographyCardCopyStyled,
  TypographyHeaderStyled,
} from './styles';

// If the card is condensed, the button overlay will kick in to handle link functionality,
// and the button props will be applied to the CTA. (buttonId and buttonUrl)

export const ProductCalloutComponent = ({
  ariaLabel,
  bgVariant,
  cardId,
  className,
  condensed,
  config,
  copy,
  icon,
  linkId,
  linkText,
  linkUrl,
  title,
  withHeaderAccent,
}) => {
  const styles = Styles();
  const IconToRender = icon;
  return (
    <DivProductCalloutCardStyled
      bgVariant={bgVariant}
      className={className}
      id={cardId}
      condensed={condensed}>
      <ProductCalloutRow>
        <Col xsmall={12}>
          <RowHeaderStyled>
            <TypographyHeaderStyled
              component='h3'
              condensed={condensed}
              withHeaderAccent={withHeaderAccent}>
              {title}
              {condensed
              && <IconCardTitleStyled
                className='icon-product-callout-arrow' />}
            </TypographyHeaderStyled>
            {icon && !condensed
            && (
              <IconToRender style={styles.IconCardMainStyled} />
            )}
          </RowHeaderStyled>
          {(copy && !condensed)
        && <TypographyCardCopyStyled>
          {copy}
        </TypographyCardCopyStyled>}
        </Col>
      </ProductCalloutRow>
      {linkText
      && (
        <ProductCalloutRow
          condensed={condensed}
          className='nmx-no-print'>
          <ColLinkContainerStyled xsmall={12}>
            <Link
              id={linkId}
              variant='primary'
              href={linkUrl}
              ariaLabel={ariaLabel}
              config={config}
              endAdornment={caratRight}>
              {linkText}
            </Link>
          </ColLinkContainerStyled>
        </ProductCalloutRow>
      )}
      {condensed
      && (
        <ButtonCondensedCardOverlayStyled
          id={`${cardId}-button`}
          aria-label={`${title}`}
          role='link'
          onClick={() => {
            jsRedirect(linkUrl);
          }}
        />)}
    </DivProductCalloutCardStyled>
  );
};

ProductCalloutComponent.propTypes = {
  bgVariant: PropTypes.string,
  cardId: PropTypes.string.isRequired,
  /** optional additional className */
  className: PropTypes.string,
  condensed: PropTypes.bool,
  config: PropTypes.shape({
    basePath: PropTypes.string,
    nmxTemplateVersion: PropTypes.string,
  }),
  copy: PropTypes.any,
  icon: PropTypes.any,
  linkId: PropTypes.string,
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
  title: PropTypes.string.isRequired,
};

ProductCalloutComponent.defaultProps = {
  bgVariant: 'secondary',
  condensed: false,
  config: {
    basePath: '<%=basePath%>',
    nmxTemplateVersion: '<%=nmxTemplateVersion%>',
  },
};

export default withTheme(ProductCalloutComponent);
